import { API_ERROR_CODES } from '@/consts/common';

type Listener = () => void;

let isLockedOut = false;
const listeners = new Set<Listener>();

function emit(): void {
  listeners.forEach((listener) => listener());
}

export function getUsageTimeLimitLockout(): boolean {
  return isLockedOut;
}

export function subscribeUsageTimeLimitLockout(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifyUsageTimeLimitLockout(): void {
  if (isLockedOut) return;
  isLockedOut = true;
  emit();
}

export function clearUsageTimeLimitLockout(): void {
  if (!isLockedOut) return;
  isLockedOut = false;
  emit();
}

export function isUsageTimeLimitError(error: unknown): boolean {
  return error instanceof Error
    && error.message === API_ERROR_CODES.USAGE_TIME_LIMIT;
}
